import { useTheme } from "../../../components/hooks/useTheme";
import { useState } from "react";
import { CustomerEnquiryList } from "./CustomerEnquiryList";

const filterItems = [
  {
    id: 0,
    label: "Customer Name",
  },
  {
    id: 1,
    label: "EmailAddress",
  },
  {
    id: 2,
    label: "PhoneNumber",
  },
]

export const CustomersEnquiry = () => {
  const { themeStyles } = useTheme();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchValue, setSearchValue] = useState<string>("");
  const [customersEnquiryFilterValue, setCustomersEnquiryFilterValue] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);


  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div>
          <CustomerEnquiryList
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            customersEnquiryFilterValue={customersEnquiryFilterValue}
            setCustomersEnquiryFilterValue={setCustomersEnquiryFilterValue}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            filterItems={filterItems}
          />
        </div>
      </div>
    </div>
  );
}


